import { render } from "./ScatterView.vue?vue&type=template&id=55a7564c"
import script from "./ScatterView.vue?vue&type=script&lang=js"
export * from "./ScatterView.vue?vue&type=script&lang=js"
script.render = render

export default script